/**
 * @generated SignedSource<<f2ca6e3060f43bbe3f3f75243a47d8e0>>
 * @relayHash 3014a96ec9501e54a7e7f2801f993a06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2e0c37341726962242b1002a9760d27e74bf1e20253453b4401e923deccb3c69

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSettingsEmbeddedWidgetsAppNewQuery$variables = {
  helpCenterAri: string;
  skip: boolean;
};
export type HelpCenterSettingsEmbeddedWidgetsAppNewQuery$data = {
  readonly csmAi_getWidgetsWithCsmAiHub?: {
    readonly __typename: "CsmAiHubWithWidgets";
    readonly " $fragmentSpreads": FragmentRefs<"EmbeddedWidgetsConfigPage_atlassianCsmWidgetConfiguration">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type HelpCenterSettingsEmbeddedWidgetsAppNewQuery = {
  response: HelpCenterSettingsEmbeddedWidgetsAppNewQuery$data;
  variables: HelpCenterSettingsEmbeddedWidgetsAppNewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppNewQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "csmAi_getWidgetsWithCsmAiHub",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "EmbeddedWidgetsConfigPage_atlassianCsmWidgetConfiguration"
                  }
                ],
                "type": "CsmAiHubWithWidgets"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppNewQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "csmAi_getWidgetsWithCsmAiHub",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EMBED"
                      }
                    ],
                    "kind": "LinkedField",
                    "name": "widgets",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                          }
                        ],
                        "type": "CsmAiWidgetConfig"
                      }
                    ],
                    "storageKey": "widgets(type:\"EMBED\")"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ],
                "type": "CsmAiHubWithWidgets"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2e0c37341726962242b1002a9760d27e74bf1e20253453b4401e923deccb3c69",
    "metadata": {},
    "name": "HelpCenterSettingsEmbeddedWidgetsAppNewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "756ef65e34543fa92d07e813c83f5c1b";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
